import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Card } from 'rmwc/Card';
import SerializeForm from 'form-serialize';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { Radio, Checkbox } from 'rmwc/Radio';
import { connect } from 'react-redux'
import GooglePlacesAutoComplete from './GooglePlacesAutoComplete'
import StatusMessage from '../util/StatusMessage'
import PlacesAutoComplete from 'react-places-autocomplete'
import GoogleTagManager from '../util/GoogleTagManager'
import ReactGA from 'react-ga';

class TQRegistration extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      tpoRefOther: false,
      currentDate: '',
      formHidden: false,
      regEligibilityHidden: true,
      partialExistHidden: true,
      data:{
        'first_name': '',
        'last_name': '',
        'email': '',
        'stateId': '',
        'countryId':'',
        'tqTypeId': '',
        'tqType': [],
        'tqTypeName': '',
        'states': [],
        'countries': [],
        'city': '',
        'tqTestTracks': [],
        'tqTestTrackId': '',
        'tqTestDates':[],
        'tqTestDate':'',
        'tqTestDateId': '',
        'teachingAssociations': [],
        'teachingAssociationId': '',
        'teachingAssociationName': '',
        'testcenters': [],
        'testcenterId': '',
        'testCenterName': '',
        'payment_modes': [],
        'paymentModeId': '',
        'trackAmount': 0,
        'discountValue': 0,
        'registrationFee': 0.0,
        'referralCode': '',
        'examDateOption': '',
        'examDate': '',
        'dob': '',
        'initialFee': '',
        'phone': '',
        'phoneDisabled': true,
        'countryDisabled': true,
        'discountDisable': false,
        'eligibility': '',
        'trackDetailMessage': '',
        'usDollarAmount': 0.0,
        'discountedDollarValue': 0.0,
        'registrationFeeInDollar': 0.0,
        'addOnOptions': [],
        'selectedAddonOption': '',
        'isAddOnAVailableForParentTrack': '',
        'trackFeeWithoutAddon': '',
        'trackFeeInDolloarWithoutAddon': '',
        'trackFeeWithAddon':'',
        'trackFeeInDolloarWithAddon':'',
        'initialFeeWithAddOn': '',
        'showPartialComponent': false,
        'certificateName': '',
        'timeSlots': [],
        'timeSlot': '',
      },
      componentState:{
        first_disable:false,
        last_disable:false,
        dob_disable:false,
      },
      saveState:{
        saveDisabled: false
      },

      formErrors:{
        'firstNameError':'',
        'lastNameError':'',
        'emailError': '',
        'cityOfResidenceError':'',
        'countryIdError':'',
        'stateIdError':'',
        'teachingAssociationIdError':'',
        'workingOrganizationError':'',
        'testCenterError': '',
        'testTrackError':'',
        'testDateError': '',
        'paymentModeError':'',
        'examDateOptionError': '',
        'examDateError': '',
        'dobError': '',
        'phoneError': '',
        'discountCouponError': '',
        'eligibilityError': '',
        'regEligibilityError': '',
        'timeSlotError': ''
      },
    };

  }

  componentDidMount(){

    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-124053817-1');
    ReactGA.pageview('/tq_registration');

    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({},this.state.formErrors)
    let componentState = Object.assign({}, this.state.componentState);
    let saveState = Object.assign({},this.state.saveState)
    let countryIdToPass
    let trackIdToPass
    let testDateId
    let  currentTime = new Date()
    let m = currentTime.getMonth() + 1
    let d = currentTime.getDate()
    let y = currentTime.getFullYear()
    let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
    let url
    let tqAddonOptionURL = `fetch/registration/options/tq`
    errorObj.regEligibilityError = ''
    saveState.saveDisabled = ''
    let formHidden = false
    let regEligibilityHidden = true
    let certificationName = this.props.match.params.name
    let partialExistHidden = true
    let paramsType = this.props.match.params.type
    let partialId = this.props.match.params.partialId
    if(paramsType === 'partial') {
      url = `partial_registrations/${this.props.match.params.partialId}`
    }
    else {
      url = `/tq/check/reg/eligibility`
    }

    api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if(result.status === 'error'){
        if(result.data.eligibility === "not_eligible"){
          errorObj.regEligibilityError = result.data.message
          saveState.saveDisabled = true
          formHidden = true
          regEligibilityHidden = false
          this.setState({formErrors: errorObj,saveState: saveState, formHidden: formHidden, regEligibilityHidden: regEligibilityHidden})
        }
        if('reg_status' in result.data){
          errorObj.regEligibilityError = result.data.message
          saveState.saveDisabled = true
          formHidden = true
          partialExistHidden = false
          this.setState({formErrors: errorObj,saveState: saveState, formHidden: formHidden, partialExistHidden: partialExistHidden})
        }
      }
      else if(result.status === 'success' && 
        ( result.data.eligibility === "eligible" || 
          (paramsType === 'partial' && partialId > 0)
        )
      ){ 
        if(paramsType === 'partial') {
          data.tqTestTrackId = result.data.registration_detail.tq_test_track_id
          trackIdToPass = data.tqTestTrackId
          data.isAddOnAVailableForParentTrack = result.data.is_add_on_association_available
          if(data.isAddOnAVailableForParentTrack){
            data.selectedAddonOption = result.data.registration_detail.is_add_on_available
          }
          data.teachingAssociationId = result.data.registration_detail.teaching_association_id
          data.teachingAssociationName = result.data.registration_detail.teaching_association_name
          data.workingOrganization = result.data.registration_detail.working_organization
          data.showPartialComponent = true
          let selectedExamDate  = result.data.registration_detail.selected_exam_date
          let  currentTime = new Date()
          let m = currentTime.getMonth() + 1
          let d = currentTime.getDate()
          let y = currentTime.getFullYear()
          let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
          if( (new Date(selectedExamDate) < currentDate) || (!selectedExamDate)){
            data.examDateOption = ''
            data.examDate = ''
            data.timeSlot = ''
          }
          else{
            data.examDateOption = result.data.registration_detail.exam_date_option
            data.examDate = result.data.registration_detail.selected_exam_date
            data.timeSlot = result.data.registration_detail.time_slot
          }
        }
        return api.getTQTestTracks(this.props.user.accessToken, certificationName)
        .then((result) => {
          data.tqTestTracks = result
          if(data.tqTestTrackId && !data.tqTestTracks.some(track => track.id === parseInt(trackIdToPass))){
            data.tqTestTrackId = ''
            data.selectedAddonOption = ''
            data.examDate = ''
          }
          return api.getTqTestCenters(this.props.user.accessToken)
        }).then((result) =>{
            data.testcenters = result
            return api.getTeachingAssociations(this.props.user.accessToken)
          }).then((result) => {
              data.teachingAssociations = result
              /*return api.getPaymentModes(this.props.user.accessToken)
            }).then((result) =>{
                data.payment_modes = result*/
                return api.getuserForRegistration(this.props.user.accessToken)
            }).then((result) =>{
                data.first_name = result.data.firstName
                data.last_name = result.data.lastName
                if(result.data.dob){
                  data.dob = result.data.dob
                }
                data.email = result.data.email
                data.stateId = result.data.stateId
                data.countryId = result.data.countryId
                data.city = result.data.city
                data.phone = result.data.phone
                if(data.first_name)
                  componentState.first_disable = true
                if(data.last_name)
                  componentState.last_disable = true
                if(data.dob)
                  componentState.dob_disable = true
                if(data.phone === undefined || data.phone === '' || data.phone === null)
                  data.phoneDisabled = false
                if(data.countryId === undefined || data.countryId == '' || data.countryId === null){
                  countryIdToPass = 0
                  data.countryDisabled = false
                }
                else
                  countryIdToPass = data.countryId
              return api.getCountries(this.props.user.accessToken)            
              }).then((result) => {
                var countryToPass = ''
                data.countries = result
                if(data.countryId != '')
                  countryToPass = data.countryId
                else
                  countryToPass = data.countries[0].id
                return api.getStates(this.props.user.accessToken, countryToPass)
                }).then((result) =>{
                  data.states = result
                  // return api.getTQTestDates('', data.testcenterId)
                  // }).then((result) =>{
                  //   data.tqTestDates = result
                    //General fee is disabled and track based fee is enabled.
                    //return api.getFeeByCertificationType('TQ')
                    //}).then((result) =>{
                      //data.trackAmount = result.amount
                      //data.registrationFee = result.amount
                      //data.usDollarAmount = result.dollar_amount
                      //data.registrationFeeInDollar = result.dollar_amount
                    return api.getTqTypes(this.props.user.accessToken)
                    }).then((result) =>{
                      data.tqType = result.data
                      data.tqTypeId = result.data[0].id
                    return api.getCountryBasedPaymentModes(this.props.user.accessToken,countryIdToPass)
                    }).then((result) =>{
                      data.payment_modes = result.data
                      return api.getResponse(this.props.user.accessToken, tqAddonOptionURL)
                    }).then((result) =>{
                      data.addOnOptions = result.data
                      data.certificateName = certificationName
                    if(data.tqTestTrackId) { 
                      api.getResponse(this.props.user.accessToken, `fetch/tq/track/fee/${data.tqTestTrackId}`)
                      .then((result) =>{
                        if(result.status === 'success'){
                          data.trackAmount = result.data.amount
                          data.registrationFee = result.data.amount
                          data.usDollarAmount = result.data.dollar_amount
                          data.registrationFeeInDollar = result.data.dollar_amount
                        // incase ofaddon should be separtely stored for display purpose
                          data.trackFeeWithoutAddon = result.data.amount
                          data.trackFeeInDolloarWithoutAddon = result.data.dollar_amount
                          data.trackFeeWithAddon = result.data.add_on_amount
                          data.trackFeeInDolloarWithAddon = result.data.add_on_dollar_amount
                          data.initialFee = result.data.inital_fee
                          data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
                        // if the user has opted for online option initally and if he is trying to update
                          if(data.selectedAddonOption){
                            data.trackAmount = data.trackFeeWithAddon
                            data.registrationFee = data.trackFeeWithAddon
                            data.usDollarAmount = data.trackFeeInDolloarWithAddon
                            data.registrationFeeInDollar = data.trackFeeInDolloarWithAddon
                          }
                        }

                        if(trackIdToPass){
                          return api.getResponse(this.props.user.accessToken, `fetch/date/time/slot?type=exam_date&tq_test_track_id=${trackIdToPass}`)
                          .then((result) => {

                            if(result.status === 'error'){
                              saveState.saveDisabled = true
                              this.setState({data: data, componentState: componentState, currentDate: currentDate, errorMsg: result.message, saveState: saveState})
                              return
                            }
                            data.tqTestDates = result.data
                            if(data.examDate && data.tqTestDates.length > 0){
                              testDateId = this.searchDate(data.examDate, data.tqTestDates)
                              if(testDateId){
                                return api.getResponse(this.props.user.accessToken, 
                                  `fetch/date/time/slot?type=time_slot&tq_test_track_id=${trackIdToPass}&test_date_id=${testDateId}`)
                                  .then((result) =>{
                                  if(result.status === 'success'){  
                                    data.timeSlots = result.data
                                  }
                                  this.setState({data: data, componentState: componentState, currentDate: currentDate, formErrors: errorObj})
                                  return
                                })
                              } else {
                                data.examDate = ''
                                data.timeSlots = ''
                                data.timeSlot = ''
                              }
                            }
                          })
                        }
                      })
                      this.setState({data: data, componentState: componentState, currentDate: currentDate, formErrors: errorObj})
                      return
                    }
                     this.setState({data: data, componentState: componentState, currentDate: currentDate, formErrors: errorObj})
                  })
        }
    })
  }

  handletqTypeChange = (event) => {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    data.tqTypeId = event.target.value
    data.tqTypeName = optionElement.getAttribute('data-name')
    this.setState({data: data})
  }

  /*handleCountriesChange = (event) =>{  
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    let countryChanged = true
    data.countryId = event.target.value
    data.countryName = optionElement.getAttribute('data-name')

    if (countryChanged) {
      api.getStates(this.props.user.accessToken, data.countryId)
      .then((states) => {
        data.states = states
        data.stateId = ''
        this.setState({data: data})
      })
    } else {
      this.setState({data: data})
    }
  }*/

  /*handleStatesChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.stateId = selectedOption
    }
    else{
      data.stateId = ''
    }
    this.setState({data: data})*/

  handleCountriesChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.countryId = event.target.value
    if(data.countryId !== ''){
      api.getCountryBasedPaymentModes(this.props.user.accessToken, data.countryId)
      .then((result) => {
        data.payment_modes = result.data
        this.setState({data: data})
      })
    }
  }

  /*handleCityChange = (value) =>{
    let data = Object.assign({}, this.state.data)
    data.city = value
    this.setState({data: data})
  }*/

  /*handleCitySelect = (address) => {
    let data = Object.assign({}, this.state.data)
    data.city = address
    this.setState({data: data})
  }*/

  handleSchoolChange =(value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleSchoolSelect = (value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleTeachingAssociationSelection = (event) =>{
        
    let data = Object.assign({}, this.state.data)
      data.teachingAssociationIdOther=''
      data.workingPositionId = ''
      data.workingPositionName =''
      data.workingOrganization=''
    if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      data.teachingAssociationId = selectedOption
      data.teachingAssociationName = optionElement.getAttribute('data-name')
    }
    else{
      data.teachingAssociationId = ''
      data.teachingAssociationName = ''
      
    }
    this.setState({data: data})

  }

  /** Test Center as option is removed from the form. To be added on later if required, 
  reason - the exams are going to be online for now 

  handleTestCenterChange = (event) =>{
 
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
      if(event.target.value){
        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]

        data.testcenterId = selectedOption
        data.testCenterName = optionElement.getAttribute('data-name')

        api.getTQTestDates('', data.testcenterId)          
        .then((result) =>{
            data.tqTestDates = result
            this.setState({data: data})         
        })

      }
      else{
         data.testcenterId = ''
         data.tqTestDates =[]
         this.setState({data: data})
      }
  }*/
  

  handleTQTestDateChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    let saveState = Object.assign({}, this.state.saveState)
    data.examDate = event.target.value
    let testDateId = this.searchDate(data.examDate, data.tqTestDates)
    let slotUrl = `fetch/date/time/slot?type=time_slot&tq_test_track_id=${data.tqTestTrackId}&test_date_id=${testDateId}`
    api.getResponse(this.props.user.accessToken, slotUrl)
    .then((result) => {
      if(result.status === 'success'){
        data.timeSlots = result.data
        data.timeSlot = ''
      }
      else if(result.status === 'error'){
        data.timeSlots = []
        data.timeSlot = ''
        saveState.saveDisabled = true
        this.setState({errorMsg: result.message, data: data, saveState: saveState})
      }

      this.setState({data: data})
    }).catch((error) => {
      this.setState({errorMsg: `Exception ${error.stack}`})
    })
  }
    // if(event.target.value){
    //   let selectedOption = event.target.value
    //   data.tqTestDateId = selectedOption
    // }
    // else{
    //   data.tqTestDateId = ''
    // }
    



  handleTestTrackChange = (event) =>{
    this.setState({errorMsg: ''})
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({},this.state.formErrors)
    let saveState = Object.assign({}, this.state.saveState)
    errorObj.eligibilityError= ''
    if(event.target.value){
      let selectedOption = event.target.value
      data.tqTestTrackId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      let url = `tq/check/track/eligibility/${data.tqTestTrackId}`
      let get_track_fee_url = `/fetch/tq/track/fee/${data.tqTestTrackId}`
      let getDatesUrl = `fetch/date/time/slot?type=exam_date&tq_test_track_id=${data.tqTestTrackId}`
      //on change of track the applied discount should be cleared
      data.discountValue = 0
      data.registrationFee = data.trackAmount
      data.registrationFeeInDollar = data.usDollarAmount
    

      if(data.referralCode !== ''){
        data.referralCode = ''
        errorObj.discountCouponError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
      }
      api.getResponse(this.props.user.accessToken, url)
      .then((result) =>{
        if(result.status === 'success'){
          data.eligibility = result.data.eligibility
          data.trackDetailMessage = result.data.track_detail
          data.isAddOnAVailableForParentTrack = result.data.is_add_on_available
        }
        else if (result.status === 'error'){
          errorObj.eligibilityError = result.message
        }

        if(data.eligibility === 'not_eligible'){
          data.referralCode = ''
          errorObj.discountCouponError = ''
          saveState.saveDisabled = true
          data.selectedAddonOption = ''
        }
        else{
          saveState.saveDisabled = false
        }
        return api.getResponse(this.props.user.accessToken, get_track_fee_url)
      }).then((result) =>{
        if(result.status === 'success'){
          data.trackAmount = result.data.amount
          data.registrationFee = result.data.amount
          data.usDollarAmount = result.data.dollar_amount
          data.registrationFeeInDollar = result.data.dollar_amount

          // incase of addons addon should be separtely stored for display purpose
          data.trackFeeWithoutAddon = result.data.amount
          data.trackFeeInDolloarWithoutAddon = result.data.dollar_amount
          data.trackFeeWithAddon = result.data.add_on_amount
          data.trackFeeInDolloarWithAddon = result.data.add_on_dollar_amount
          data.initialFee = result.data.inital_fee
          data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
        }
        return api.getResponse(this.props.user.accessToken, getDatesUrl)
      }).then((result) => {

        if(result.status === 'success'){
          data.tqTestDates = result.data
          data.examDate = ''
          data.timeSlots = []
          data.timeSlot = ''
        }
        else if(result.status === 'error'){
          saveState.saveDisabled = true
          data.tqTestDates = []
          data.timeSlots = []
          data.timeSlot = ''
          this.setState({errorMsg: result.message, data: data, saveState: saveState})
        }

        //reset add on selection
        data.selectedAddonOption = ''
        this.setState({data: data, formErrors: errorObj, saveState: saveState})
      }).catch((error) => {
        this.setState({errorMsg: `Exception - ${error.stack}`})
      })
    }

      //Commenting for TQ restrictions - 30-05-2020
      //Change - Moving to Flat fee structure from test track based. 
      //To be brought back when the TQ moves to test track based fee structure
      /**data.trackAmount = optionElement.getAttribute('track-amount')
      data.registrationFee = data.trackAmount
      */
      //Change - Moving to Flat fee structure from test track based. 
      //To be brought back when the TQ moves to test track based fee structure
      /**data.trackAmount = optionElement.getAttribute('track-amount')
      data.registrationFee = data.trackAmount
      */
    //}
    //else{
      //Change - Moving to Flat fee structure from test track based. 
      //To be brought back when the TQ moves to test track based fee structure
      /**
      data.trackAmount = 0
      */
     //data.tqTestTrackId = ''
    //}
  }

  handlePaymentModeChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = event.target.value
    this.setState({data: data})
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;  
    this.setState({data});
  }

  onAddonOptionChange = (evt) => {
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({},this.state.formErrors)
    let valuetoSet =  parseInt(evt.target.value)
    
    //Clear discount on change of Online selection
    data.discountValue = 0
    //Set the flag for ui and change the fee based on selection
    if(data.referralCode !== ''){
      data.referralCode = ''
      errorObj.discountCouponError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
    }
    
    if(this.state.data.selectedAddonOption !== ''){
      data[evt.target.name] = ''
      data.registrationFee = data.trackFeeWithoutAddon
      data.trackAmount = data.trackFeeWithoutAddon
      data.usDollarAmount = data.trackFeeInDolloarWithoutAddon
      data.registrationFeeInDollar = data.trackFeeInDolloarWithoutAddon
    }
    else{
       data[evt.target.name] = valuetoSet
       data.registrationFee = data.trackFeeWithAddon
       data.trackAmount = data.trackFeeWithAddon
       data.usDollarAmount = data.trackFeeInDolloarWithAddon
       data.registrationFeeInDollar = data.trackFeeInDolloarWithAddon
    }
      
    //Reset Discount
    data.discountValue = 0
   
    this.setState({data: data, formErrors: errorObj})
  }

  handleSubmit = (e) =>{
    e.preventDefault()
    this.processRegistration(false)
  }

  handleSubmitAndProceed = (e) =>{
    e.preventDefault()
    this.processRegistration(true)
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.firstNameError = ''
    errorObj.lastNameError = ''
    errorObj.emailError = ''
    errorObj.teachingAssociationIdError =''
    errorObj.workingOrganizationError = ''
    errorObj.cityOfResidenceError =''
    errorObj.countryIdError =''
    errorObj.stateIdError =''
    errorObj.testCenterError =''
    errorObj.testTrackError =''
    errorObj.testDateError=''
    errorObj.paymentModeError =''
    errorObj.examDateOptionError =''
    errorObj.examDateError =''
    errorObj.dobError=''
    errorObj.phoneError=''
    errorObj.timeSlotError=''

    if(!data.first_name){
        errorObj.firstNameError ='First Name is mandatory'
        error = false
      }

      if(!data.last_name){
        errorObj.lastNameError ='Last Name is mandatory'
        error = false
      }

      if(!(data.dob) || data.dob === ''){
        errorObj.dobError ='Date of Birth is mandatory'
        error = false
      }

      if(!(data.email) || data.email === ''){
        errorObj.emailError ='Email is mandatory'
        error = false
      }
      else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(data.email)){
          errorObj.emailError ='Invalid Email Format'
          error = false
        }
      }

      if(!(data.countryId) || data.countryId === ''){
        errorObj.countryIdError ='Country is mandatory'
        error = false
      }

      if(data.phone === '' || data.phone === null || data.phone === undefined){
        errorObj.phoneError = 'Mobile Number is mandatory'
        error = false
      }

      else if(((data.countryId === '1') || (data.countryId === 1)) && (!data.phoneDisabled)){
        if((!data.phone.startsWith('91')) || (data.phone.length < 12)){
          errorObj.phoneError = 'Please add country to your mobile number (no space or + needed).'
          error = false
        }
      }

      else if(((data.countryId !== 1) || (data.countryId !== '1')) && (!data.phoneDisabled)){
        var phoneno = /^\d{8,14}$/;
        if(!data.phone.match(phoneno)){
          errorObj.phoneError ='Please add country to your mobile number (no space or + needed).'
          error = false
        }
      }

      /*if(data.city === ''){
        errorObj.cityOfResidenceError ='City is mandatory'
        error = false
      }*/

      if(data.teachingAssociationId === ''){
        errorObj.teachingAssociationIdError ='Occupation is mandatory'
        error = false
      }

      if(data.teachingAssociationId && !(data.teachingAssociationName === 'No association with teaching' || data.teachingAssociationName === 'Tuition Teacher')){
        if(data.workingOrganization  === ''){
          errorObj.workingOrganizationError ='Please enter the name of School/Organization/Institute'
          error = false
        }
      }

      // if(!(data.examDateOption) || data.examDateOption === ''){
      //   errorObj.examDateOptionError ='Please Choose Exam Option as either Immediate or Future'
      //   error = false
      // }

      if(!data.examDate){
        errorObj.examDateOptionError ='Exam date is mandatory'
        error = false
      }

      if(!(data.paymentModeId) || data.paymentModeId === ''){
        errorObj.paymentModeError = 'Payment Mode is mandatory'
        error = false
      }

      if(!(data.tqTestTrackId) || data.tqTestTrackId === ''){
        errorObj.testTrackError = 'Test Track is mandatory'
        error = false
      }

      if((data.timeSlots.length > 0) && (!data.timeSlot)){
        errorObj.timeSlotError = 'Please choose a time slot'
        error = false
      }


      let saveState = Object.assign({}, this.state.saveState)
      if(!error){        
        saveState.saveDisabled = false
      }
      else{
        saveState.saveDisabled = true
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
        saveState: saveState
      })
      return error
  }

  processRegistration = (isPayment) => {
    let data = Object.assign({}, this.state.data)
    let certificateName = this.state.data.certificateName.toUpperCase()
    if(this.validateForm()){
      let apiInput = {
       'certification_participation': {
        'certification_type_id': '4',    
        },      
        'tq_certification': {         
          'working_organization': data.workingOrganization,
          'teaching_association_id': data.teachingAssociationId,
          'test_center_id': data.testcenterId,
          'referral_code': data.referralCode,
          'global_type_id': data.tqTypeId,
          'exam_date_option': 'Future',
          'selected_exam_date': data.examDate,
          'source_of_reg': `Web_inside_form_${certificateName}`,
          'time_slot': data.timeSlot,
        },      
        'payment': {
          'payment_mode_id': data.paymentModeId,
          'currency': 'RS'
        },      
        'tq_certification_detail': {
          'tq_test_track_id': data.tqTestTrackId,
          'global_type_id': data.selectedAddonOption,
        },
        'user':{
          'email': data.email,
          'phone': data.phone
        },
        'personal_info':{
          'first_name': data.first_name,
          'last_name': data.last_name,
          'dob': data.dob,
        },
        'address':{
          'city': data.city,
          'state_id': data.stateId,
          'country_id': data.countryId
        },
        'payment_option':{
          'is_payment': isPayment
        }
      }
      // values end
      if(isPayment){
        ReactGA.set({ userId: this.props.user.id });    
        ReactGA.initialize('UA-124053817-1');
        ReactGA.event({
          category: 'Other',
          action: 'Save and Pay TQ'
        });
     }
      else{
        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-124053817-1');
        ReactGA.event({
          category: 'Other',
          action: 'Save Button TQ'
        });
      }
      
       api.saveTqCertifications(this.props.user.accessToken,apiInput)
      .then((result) => {
             
        if(result.errors){
          let saveState = Object.assign({}, this.state.saveState)
          saveState.saveDisabled = false
          this.setState({ errorMsg: result.errors, saveState: saveState })
        }
        else{
          if(result.redirect_to)
          window.location.href = result.redirect_to;
          else
            this.props.history.push("/portal/app/my_registrations")
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })


    }
  }


  handleDiscountApply =(e) =>{
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({}, this.state.formErrors)
    errorObj.discountCouponError = ''
    if(data.tqTestTrackId === ''){
      data.referralCode = ''
      errorObj.discountCouponError = 'Please choose a Test Track to avail discount.'
      this.setState({data: data,formErrors: errorObj})
    }
    else{
      api.getTQDiscountPerTrack('',4, this.state.data.referralCode, data.trackAmount, data.tqTestTrackId, data.selectedAddonOption)
        .then((result) => {
          
          if(result.status === 'success'){
            data.discountValue =  Number(result.discount)
            data.discountedDollarValue = Number(result.discountedDollarAmount)
            data.registrationFee = data.trackAmount - data.discountValue
            data.registrationFeeInDollar = data.usDollarAmount - data.discountedDollarValue
            data.registrationFeeInDollar = data.registrationFeeInDollar.toFixed(2)
            errorObj.discountCouponError = result.message
          }
          else if(result.status === 'error'){
            errorObj.discountCouponError = result.message
            data.discountValue = 0
            data.registrationFee = data.trackAmount
            data.registrationFeeInDollar = data.usDollarAmount
          }
          else{
            data.discountValue = 0
            data.registrationFee = data.trackAmount
            data.registrationFeeInDollar = data.usDollarAmount
          }
          this.setState({data: data, formErrors: errorObj})
      })
    }
  }

  onCertificateNameChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    api.getTQTestTracks(this.props.user.accessToken, evt.target.value)
      .then((result) => {
        data.tqTestTrackId = ''
        data.tqTestTracks = result
        data.selectedAddonOption=''
        data.examDate = ''
        data.tqTestDates = []
        data.timeSlot = ''
        data.timeSlots = []
        this.setState({data});  
      })
  }

  searchDate(nameKey, testDates){
    for (var i=0; i < testDates.length; i++) {
        if (testDates[i].exam_date === nameKey) {
          return testDates[i].test_date_id;
      }
    }
  }

  handleTQTimeSlotChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.timeSlot = event.target.value
    this.setState({data: data})
  }


  render() {
    let tqTypeComponent
    /*new field on 23/05/2020*/
    let mobileComponent

    mobileComponent = (
      <GridCell span = "12">
          <TextField  type = "number" label = "Mobile No" className='text_input' autoComplete ="off" name ="phone" value ={this.state.data.phone} onChange={this.onInputChange}/>
      </GridCell>
      )

    tqTypeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select
            name="type"
            onChange={this.handletqTypeChange}
            value={this.state.data.tqTypeId}
            className="mdc-select__native-control two-col-input">
            {this.state.data.tqType.map(function(tqTypes){
                return(<option key={tqTypes.id} value={tqTypes.id} data-name={tqTypes.name}>
                  {tqTypes.name} 
                </option>)
            })}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Type</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>)

    let TeachingOtherComponent
    if(this.state.data.teachingAssociationId && !(this.state.data.teachingAssociationName === 'No association with teaching' || this.state.data.teachingAssociationName === 'Tuition Teacher')){
      TeachingOtherComponent =(
        <PlacesAutoComplete
          value={this.state.data.workingOrganization}
            onChange={this.handleSchoolSelect}
            onSelect={this.handleSchoolChange}
            >
            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div>
              <TextField
                {...getInputProps({
                  placeholder: 'School/Organization/Institute',
                  className: 'location-search-input'
                })}
                name="school"
                
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map(suggestion => {
                  const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                              ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                              : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div {...getSuggestionItemProps(suggestion, { className, style })}>
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </PlacesAutoComplete>
      )
    }


    let regAmountComponent
    let discountTextComponent
    let listDateComponent


    if(this.state.data.trackAmount > 0){
      let regFee = this.state.data.registrationFee
      let regFeeWithoutGST = regFee / 1.18
      let initialFee;
      if(this.state.data.selectedAddonOption === '') {
        initialFee = this.state.data.initialFee
      }
      else if (this.state.data.selectedAddonOption !== ''){
        initialFee = this.state.data.initialFeeWithAddOn
      }
      //regAmountComponent = <h4> Total registration fee Rs {this.state.data.registrationFee}{'/-'} (Rs.{parseFloat(regFeeWithoutGST).toFixed(2)} + 18% GST) approx ${this.state.data.registrationFeeInDollar} in US dollars.</h4>
      let percentDiscount = Math.floor(100-(regFeeWithoutGST/initialFee)*100)
      //discountTextComponent = <h5> (Post a {percentDiscount}% discount on the original fee of INR 1500 + GST) </h5>
      regAmountComponent = <p> Registration fee: <del>Rs {initialFee} + GST</del> <b>You Pay:</b> Rs {parseFloat(regFeeWithoutGST).toFixed(2)} + GST(Rs {this.state.data.registrationFee})/USD {parseFloat(this.state.data.registrationFeeInDollar).toFixed(2)}.<br/>{percentDiscount}% discount.</p>
    }
    //else{
    //  regAmountComponent = <h4> Total Registraion Fee Rs. {this.state.data.registrationFee} /-</h4>  
    //}


    let paymentModeComponent
    paymentModeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select 
            name="payment_mode"
            onChange={this.handlePaymentModeChange}
            value={this.state.data.paymentModeId}
            className="mdc-select__native-control two-col-input"
          >
            <option value="" selected="">--Select Payment Mode--</option>
            {this.state.data.payment_modes.map(function(payment_mode){
              
              //if(!(payment_mode.id === 3 || payment_mode.id === 2))
                return(<option key={payment_mode.id} value={payment_mode.id} data-name={payment_mode.name}>
                  {payment_mode.name} 
                </option>)
            })}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Payment Options</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>)

    let examDateComponent
    let minDate = new Date()
    if(this.state.data.examDateOption === 'Future'){
      examDateComponent = (<GridCell span="12">
        <TextField type="date" min={this.state.currentDate} className="datepicker-padding" label="Exam Date" autoComplete="off" name="examDate" onChange={this.onInputChange} value={this.state.data.examDate}/>
      </GridCell>)
    }

    //Initally have disabled Save and Pay for international users now enabled that too.
    let saveComponent
    //if((this.state.data.countryId !== '') && (this.state.data.countryId === '1' || this.state.data.countryId === 1)){
      saveComponent = ( 
      <GridCell span="6">
        <Button raised disabled={this.state.saveState.saveDisabled}>Save</Button>
        <Button raised onClick={this.handleSubmitAndProceed} className="confirm-proceed-button" disabled={this.state.saveState.saveDisabled}>Save & Pay</Button>
    </GridCell>  
    )//}
    //else{
    //  saveComponent = (
    //  <GridCell span="6">
    //    <Button raised disabled={this.state.saveState.saveDisabled}>Save</Button>
    //   </GridCell>)
    //}

    let trackEligbilityComponent
    if(this.state.data.eligibility === 'not_eligible'){
      trackEligbilityComponent = (<GridCell span="12" style={{color: "red"}}>{this.state.data.trackDetailMessage}</GridCell>)
    }

    //add On Option component
    let isTrackSelectedAndAddonAvailable = false
    if((this.state.data.tqTestTrackId !== '' && this.state.data.isAddOnAVailableForParentTrack !== '') && !(this.state.saveState.saveDisabled)){
      isTrackSelectedAndAddonAvailable = true
    }

    let addonOpptionComp = (

      <GridCell span="12">
        {this.state.data.addOnOptions.map(addonOption => (
          <label key={addonOption.id}>

            <input type="checkbox" disabled={!isTrackSelectedAndAddonAvailable} name="selectedAddonOption" value={addonOption.id} checked={this.state.data.selectedAddonOption === addonOption.id } onChange={this.onAddonOptionChange} style={{verticalAlign: 'sub', zoom: '1.5', marginRight: '6px'}}/>
            
            Select this if you want to take up the 'Online Teaching' component in addition to this track (additional fee of INR 400 applicable). 
          
          </label>
        ))}
      </GridCell>

    )

    let showPartialComponent
    if(this.state.data.showPartialComponent) {
      showPartialComponent = (
        <React.Fragment>
          <GridCell span="6">
            Certification Type: 
            <Radio name="certificateName" value="TQ" checked={this.state.data.certificateName == 'TQ'} onChange={this.onCertificateNameChange}>
              TQ
            </Radio>
            <Radio name="certificateName" value="TPO" checked={this.state.data.certificateName == 'TPO'} onChange={this.onCertificateNameChange}>
              TPO
            </Radio>
          </GridCell>
          <GridCell span="6" />
        </React.Fragment>
      )
    }
    
      listDateComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testDate"
                onChange={this.handleTQTestDateChange}
                value={this.state.data.examDate}
                className="mdc-select__native-control two-col-input"
                disabled={this.state.saveState.saveDisabled}
              >
                <option value="" selected="">--Select Exam Date--</option>
                {this.state.data.tqTestDates.map(testDate => (
                  <option key={testDate.test_date_id} value={testDate.examDate} data-name={testDate.exam_date}>
                    {testDate.exam_date} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Exam Date</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>
      ) 

    let timeSlotComponent
    if(this.state.data.timeSlots.length > 0) {
      timeSlotComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testcenter"
                onChange={this.handleTQTimeSlotChange}
                value={this.state.data.timeSlot}
                disabled={this.state.saveState.saveDisabled}
                className="mdc-select__native-control two-col-input"
              >
                <option value="" selected="">--Select Time Slot--</option>
                {this.state.data.timeSlots.map(slot => (
                  <option key={slot.time_slot_id} value={slot.timeSlot} data-name={slot.time_slot}>
                    {slot.time_slot} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Time Slot</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>
      )
    }
    

    return (
      <Grid>
        <GridCell span="12">
          <div hidden={this.state.regEligibilityHidden}>
            <Card style={{padding: '25px'}}>
              <Typography use="headline5">CENTA {this.props.match.params.name} Registration Form</Typography>
              <br/>
              <StatusMessage error_msg = {this.state.formErrors.regEligibilityError}/>
            </Card>
          </div>
          <div hidden={this.state.partialExistHidden}>
            <Card style={{padding: '25px'}}>
              <Typography use="headline5">CENTA {this.props.match.params.name} Registration Form</Typography>
              <br/>
              <StatusMessage error_msg = {this.state.formErrors.regEligibilityError}/>
              <Typography use="subtitle" style={{color: "red"}}>Please <a href='/portal/app/my_registrations'>Click here </a>to edit details of your existing registration/ complete it.</Typography>
            </Card>
          </div>
          <div  hidden={this.state.formHidden}>
            <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
              <Card style={{padding: '25px'}}>
                <Typography use="headline5">CENTA {this.props.match.params.name} Registration Form</Typography>
                <Grid className="opportunity-list-item">

                  <GridCell span="6">
                    <TextField fullwidth className='text_input' label="First Name" autoComplete="off" name="first_name" onChange={this.onInputChange} value={this.state.data.first_name || ""} disabled={this.state.componentState.first_disable}/>
                  </GridCell>
                  <GridCell span="6"></GridCell>
                  
                  <GridCell span="6">                  
                    <TextField fullwidth className='text_input' label="Last Name" autoComplete="off"  name="last_name" onChange={this.onInputChange} value={this.state.data.last_name || ""} disabled={this.state.componentState.last_disable}/>
                  </GridCell>
                  <GridCell span="6"></GridCell>
                  
                  <GridCell span="6">
                    <TextField fullwidth className='text_input' label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email || ""}/>
                  </GridCell>
                  <GridCell span="6"></GridCell>

                  {mobileComponent}

                  <GridCell span="6">
                    <TextField type="date" className="datepicker-padding" max={this.state.currentDate} label="Date of Birth" autoComplete="off"  name="dob" onChange={this.onInputChange} value={this.state.data.dob} disabled={this.state.componentState.dob_disable}/>
                  </GridCell>
                  <GridCell span="6"></GridCell>

                  <GridCell span="6"> 
                  </GridCell>
                  <GridCell span="6"/>
                
                  <GridCell span="6">
                    <div className="full-width">
                      <div className="mdc-select" role="listbox">
                        <select 
                          name="country"
                          onChange={this.handleCountriesChange}
                          value={this.state.data.countryId}
                          className="mdc-select__native-control two-col-input"
                          disabled = {this.state.data.countryDisabled}
                        >
                          <option value="" selected="">--Select Country--</option>
                          {this.state.data.countries.map(country => (
                            <option key={country.id} value={country.id} data-name={country.name}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                        <label className="mdc-floating-label mdc-floating-label--float-above">Country</label>
                        <div className="mdc-line-ripple"></div>
                      </div>
                    </div>
                  </GridCell>
                  

                  <GridCell span="6">
                   {this.state.data.states.length !=0 &&
                    <Select
                      name="state"
                      onChange={this.handleStatesChange}
                      value={this.state.data.stateId}
                      className="select-component"
                      placeholder='-- Select State of residence --'
                      hidden
                    >
                      {this.state.data.states.map(state => (
                        <option key={state.id} value={state.id} data-name={state.name}>
                          {state.name}
                        </option>
                      ))}
                    </Select>
                   }
                  </GridCell>

                  <div style ={{display: 'none'}}>
                    <GridCell span="6">
                      <GooglePlacesAutoComplete value={this.state.data.city} handleCityChange={this.handleCityChange} handleCitySelect={this.handleCitySelect} hidden/>
                    </GridCell>
                    <GridCell span="6"></GridCell>
                  </div>

                  {showPartialComponent}

                  <GridCell span="6">
                   <div className="full-width">
                      <div className="mdc-select" role="listbox">
                        <select 
                          name="teachingAssociation"
                          onChange={this.handleTeachingAssociationSelection}
                          value={this.state.data.teachingAssociationId}
                          className="mdc-select__native-control two-col-input"
                        >
                          <option value="" selected="">--Select Occupation--</option>
                          {this.state.data.teachingAssociations.map(level => (
                            <option key={level.id} value={level.id} data-name={level.name}>
                              {level.name}
                            </option>
                          ))}
                        </select>
                        <label className="mdc-floating-label mdc-floating-label--float-above">Occupation</label>
                        <div className="mdc-line-ripple"></div>
                      </div>
                    </div>
                  </GridCell>
                  <GridCell span="6"> </GridCell>

                  <GridCell span="6">
                    {TeachingOtherComponent}
                  </GridCell>
                  <GridCell span="6"/>
                  
                  

                  {/*<GridCell span="6">
                    Take the test on: 
                    <Radio name="examDateOption" value="Immediate" checked={this.state.data.examDateOption == 'Immediate'} onChange={this.onInputChange}>
                      Today
                    </Radio>
                    <Radio name="examDateOption" value="Future" checked={this.state.data.examDateOption == 'Future'} onChange={this.onInputChange}>
                      On a Later Date
                    </Radio>
                  </GridCell>       
                  <GridCell span="6"/>  
                  {examDateComponent}
                */}

                <GridCell span="6">
                  <div className="full-width">
                      <div className="mdc-select" role="listbox">
                        <select 
                          name="testcenter"
                          onChange={this.handleTestTrackChange}
                          value={this.state.data.tqTestTrackId}
                          className="mdc-select__native-control two-col-input"
                        >
                          <option value="" selected="">--Select Test Track--</option>
                          {this.state.data.tqTestTracks.map(testTrack => (
                            <option key={testTrack.id} value={testTrack.id} data-name={testTrack.name} track-amount={testTrack.amount}>
                              {testTrack.name} 
                            </option>
                          ))}
                        </select>
                        <label className="mdc-floating-label mdc-floating-label--float-above">Test Track</label>
                        <div className="mdc-line-ripple"></div>
                      </div>
                    </div>
                </GridCell>
                <GridCell span ="6"/>

                {trackEligbilityComponent}

                {addonOpptionComp}

                <GridCell span ="6">
                  {listDateComponent}
                  <GridCell span ="6"/>
                  <br />
                  {timeSlotComponent}
                </GridCell>
                <GridCell span ="6"/>
                
                <GridCell span="6">
                    <TextField className='text_input' label="Enter referral code (if any)" autoComplete="off" className="two-col-input" name="referralCode" onChange={this.onInputChange} value={this.state.data.referralCode} disabled={this.state.saveState.saveDisabled} />
                    <Button onClick={this.handleDiscountApply} disabled={this.state.saveState.saveDisabled}>Apply</Button>
                    <br/>
                    <StatusMessage error_msg = {this.state.formErrors.discountCouponError}/>
                </GridCell>
                <GridCell span="6"/>

                <GridCell span="12">
                  {regAmountComponent}
                  {discountTextComponent}
                </GridCell>

                <GridCell span="6">
                  {paymentModeComponent}
                </GridCell>
                <GridCell span="6"/>

                

                <GridCell span="12">
                  <Typography use="subtitle">By clicking on Save/ Save and Pay, I agree to these <a href=" https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/TQ_Updated%20T&Cs_11June.pdf" target="_blank">Terms and Conditions.</a></Typography>
                </GridCell>
                {saveComponent}            
                <GridCell span="12">
                <StatusMessage error_msg = {this.state.errorMsg}/>
                <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
                <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
                <StatusMessage error_msg = {this.state.formErrors.emailError}/>
                <StatusMessage error_msg = {this.state.formErrors.dobError}/>
                <StatusMessage error_msg = {this.state.formErrors.phoneError}/>
                <StatusMessage error_msg = {this.state.formErrors.teachingAssociationIdError}/>
                <StatusMessage error_msg = {this.state.formErrors.workingOrganizationError}/>
                
                <StatusMessage error_msg = {this.state.formErrors.cityOfResidenceError}/>
                <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
                <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
                <StatusMessage error_msg = {this.state.formErrors.testTrackError}/>
                <StatusMessage error_msg = {this.state.formErrors.testDateError}/>
                <StatusMessage error_msg = {this.state.formErrors.testCenterError}/>
                <StatusMessage error_msg = {this.state.formErrors.examDateOptionError}/>
                <StatusMessage error_msg = {this.state.formErrors.eligibilityError}/>
                <StatusMessage error_msg = {this.state.formErrors.timeSlotError}/>
                </GridCell>
                </Grid>
              </Card>
            </form>
          </div>
        </GridCell>
      </Grid>  

    )

  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TQRegistration);


// WEBPACK FOOTER //
// ./src/views/TQRegistration.jsx